__webpack_require__.p = "/Supa-Smoothies/";